import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { get_reflection,get_list_of_users_reflection, get_simulation_detail_summary, get_best_attempt, get_reflection_report } from '../services/api';
import { rootRoute } from "../../../config";
import { errorMsg, instruMsg } from "../../../helper/helpers";
import { motion } from "framer-motion";
import warning_decision from '../assets/warning_decision.png';
import task_indicator_achieved from '../assets/task_indicator_achieved.png';
import task_indicator_notachieved from '../assets/task_indicator_notachieved.png';
import Button from '../../common/Button'
import FcModuleStyle from '../styles/fc.module.css';
import Reflection from "./Reflection"

const ReflectionReview = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const [listOfUsers, setListOfUsers] = useState([]);
    const [reflectionReport, setReflectionReport] = useState([]);
    const [selectedSessionid, setSelectedSessionid] = useState("");
    const [instructorPageHeight, setInstructorPageHeight] = useState("");
    const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError] = useOutletContext();

    const [reflection, setReflection] = useState({});
    const [isRequestLoading, setIsRequestLoading] = useState(false);
    let session_id = queryParams.get("sid");
    let resource_id = queryParams.get("resid");
    let course_id = queryParams.get("cid");
    let user_id = queryParams.get("userid");

    const getListOfUsers = () => {
        (session_id != undefined || session_id != undefined) && get_list_of_users_reflection(session_id, resource_id, course_id).then(
            (response) => { 
                if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                    setError(response?.data)
                }
                else{
                setListOfUsers(response?.data);
                response?.data.map((usr,index)=>{
                    if(index == 0 && user_id == undefined){                       
                        setSelectedSessionid(usr.sessionid);
                        triggerChangeEvent(usr.sessionid);
                    }else if(index == 0){ 
                        let userSessionId = response.data.find(user => user.xluserid == user_id).sessionid
                        setSelectedSessionid(userSessionId);
                        // getSimulationDetailSummary();
                    }
                }) 
            }
            }
        ).catch((error) => {
            // setError(error.status == 404 ? instruMsg : errorMsg);
            setError({"id":"00000","msg":error.status == 404 ? instruMsg : errorMsg})
            console.log(error);
        })
    };
    const get_reflectionData = () => {
        if(!isRequestLoading){
            get_reflection(selectedSessionid).then((response) => {
                if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                    setError(response?.data)
                }
                else {
                    if (typeof response != 'undefined') {
                        response.data.mode = "review"
                        setReflection(response?.data);
                        setIsLoader(false);
                        setIsOverlay(false);
                        setIsRequestLoading(false);
                    }
                }
            }).catch((error) => {
                // setError("Only instructor can change settings.");
                //setError({"id":"00000","msg":"Only instructor can change settings."})
                console.log(error);
            })
        }
       
      
    }  
    const getReflectionReport = () => {
        (session_id != undefined) && get_reflection_report(session_id,selectedSessionid).then(
            (response) => {
                if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                    setError(response?.data)
                }
                else{
                setReflectionReport(response?.data);
                // setIsLoader(false);
                // setIsOverlay(false);
            }
            }
        ).catch((error) => {
            // setError(errorMsg);
            setError({"id":"00000","msg":errorMsg})
            console.log(error);
        })
    };
    const escapeCSVValue = (value) => {
        if (value === null || value === undefined) {
            return '';
        }
        value = value.toString();
        if (value.includes('"') || value.includes(',') || value.includes('\n')) {
            return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
    };
    const convertToCSV = (data, formatType) => {
        const headers = ["LastName", "FirstName","Satisfaction", "Alignment", "Influence Factors", "Prework Completion", "Prework Preparation", "Insights", "Application", "Application-Comment", "Decision Making"];
        const rows = data.map(item => headers.map(header => {
            if (header === "Application" && Array.isArray(item[header])) {
                return escapeCSVValue(item[header].join('\n'));
            }
            return escapeCSVValue(item[header]);
        }).join(','));
        return [headers.join(','), ...rows].join('\n');
    };
    const exportCSV = (bestAttemptArr, formatType) => {
        const csvData = convertToCSV(bestAttemptArr, formatType);
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('download', 'OmsimsReflection.csv');
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    const exportCSVOfSummary = () => {
        setIsLoader(true);
        const formatType = new Date().toString().split("(")[1].replace(/\(|\)/g, "");
        // console.log(formatType);
        exportCSV(reflectionReport?.sort((a, b) =>
            a.last_name.localeCompare(b.last_name)
        )?.map((gbAttObj) => {
            let selUserData = listOfUsers?.find((user)=>user.sessionid == gbAttObj["sessionid"])
            return {
            // ["Username"] : selUserData?.name,
            ["LastName"]: `${gbAttObj?.last_name}`,
            ["FirstName"]: `${gbAttObj?.first_name}`,
            ["Satisfaction"]: gbAttObj.satisfaction ? gbAttObj.satisfaction : null,
            ['Alignment']: gbAttObj.alignment ? gbAttObj.alignment : null,
            [`Influence Factors`]: gbAttObj.influenceFactors ? gbAttObj.influenceFactors : null,
            ['Prework Completion']: gbAttObj.preworkCompletion ? gbAttObj.preworkCompletion : null,
            [`Prework Preparation`]: gbAttObj.preworkPreparation ? gbAttObj.preworkPreparation : null,
            ['Insights']: gbAttObj.insights ? gbAttObj.insights : null,
            ['Application']: gbAttObj.application ? gbAttObj.application : null,
            ['Application-Comment']: gbAttObj['application-Comment'] ? gbAttObj['application-Comment'] : null,
            ['Decision Making']:gbAttObj.decisionMaking ? gbAttObj.decisionMaking : null
            
        }}), formatType)
        setTimeout(() => setIsLoader(false), 500);
    }
    const triggerChangeEvent = (newValue) => {
        // Create a new input event
        const inputElement = document.querySelector('select');
        const event = new Event('change', { bubbles: true });
        
        // Set the new value as the input's value
        Object.defineProperty(event, 'target', {
          writable: false,
          value: { value: newValue },
        });
      
        // Dispatch the event
        inputElement.dispatchEvent(event);
    };

    const calculateHeight = () => {
        const headerHeight = window.$("#instructorreviewContainer header").outerHeight(true);
        const selectHeight = window.$("#selectUser").outerHeight(true);
        const footerHeight = window.$(window.$(`footer.footer`)[0]).outerHeight(true);
        const instructorReviewPageHeight = window.$(window).height() - headerHeight - footerHeight-selectHeight; 
        setInstructorPageHeight(instructorReviewPageHeight+"px");
    }
    useEffect(() => {
        document.querySelector("header.header").style.display = "none";
        if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
            document.querySelector("footer.footer .footer-nav .footer-links").firstChild.style.display = "none";
        }
        document.title = "Inventory Management Reflection | Instructor Review";
        return () => {
            if (document.getElementById("instructorreviewContainer") != undefined) {
                document.getElementById("instructorreviewContainer").childNodes[0].style.display = "block";
            }

            if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
                document.querySelector("footer.footer .footer-nav .footer-links").style.display = "block";
            }
            if (document.querySelector("footer.footer .container") != null) {
                document.querySelector("footer.footer .container").style.justifyContent = "space-between";
            }
        };
    }, [simObj?.sessionid])
    useEffect(() => {
        getListOfUsers();
        getReflectionReport();
        document.querySelector(".App .row").style.minHeight = "auto";
        calculateHeight();
        return () => {
            document.querySelector(".App .row").style.minHeight = "100vh";
        }
    }, [])

    useEffect(()=>{
        if(selectedSessionid){
            get_reflectionData();
        }
    },[selectedSessionid])

    useEffect(()=>{
        if(Object?.keys(reflection).length > 0){
            setInstructorPageHeight("auto")
        }
        else{
            calculateHeight();
        }
    },[reflection])


    return (
        <motion.div id="instructorreviewContainer" className={`${FcModuleStyle['instructorreview-container']} ${FcModuleStyle['reflection-review']}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} >
            <header className={`header ${FcModuleStyle.header}`}>
                <div className={`container ${FcModuleStyle.container}`}>
                    <h1>OM Simulation Reflection</h1>
                    <div className={`${FcModuleStyle['btn-dropdown-container']}`}>
                        {/* <Button clickEventHandler={exportCSVOfSummary} btnClass={"ui button export-summary"} btnName={"Export Class Summary"} /> */}
                        <Button clickEventHandler={exportCSVOfSummary} btnClass={"ui button export-summary"} btnName={"Download Feedback"} />

                        {/* <select value={selectedSessionid || ""} className={`ui dropdown ${FcModuleStyle.ui} ${FcModuleStyle.dropdown}`} onChange={(e) => setSelectedSessionid(e.target.value)}>
                            {
                                listOfUsers?.sort((a, b) => ((b.name > a.name) ? -1 : 1))?.map((user, index) => (
                                    <option key={index + "_05"} value={user.sessionid}>{user.name}</option>
                                ))
                            }
                        </select> */}
                    </div>
                </div>
            </header>
            <div style={{margin:"20px"}} id="selectUser">
            <span>Select Student:-</span>
            <select value={selectedSessionid || ""} className={`ui dropdown ${FcModuleStyle.ui} ${FcModuleStyle.dropdown}`} onChange={(e) => {
                setSelectedSessionid(e.target.value);
                setIsLoader(true);
            }
            }>
                            {
                                listOfUsers?.sort((a, b) => ((b.name > a.name) ? -1 : 1))?.map((user, index) => (
                                    <option key={index + "_05"} value={user.sessionid}>{user.name}</option>
                                ))
                            }
                        </select>
            </div>
            <div className={`${FcModuleStyle['instructor-table']} ${FcModuleStyle['instruct-tbl']}`} style={{ height: instructorPageHeight }}>
                {
                    <Reflection from="instructorReview" refData={reflection}/>
                }
            </div>
        </motion.div>
    );
}

export default ReflectionReview